const versionActions = [
  {
    value: 'respond',
    label: 'Respond',
    icon: 'rule',
    iconLibrary: 'material',
    isPrimary: true,
  },
];
const versionActionsMap = Object.fromEntries(versionActions.map((o) => [o.value, o]));

export {
  versionActions,
  versionActionsMap,
};
